import * as Yup from 'yup';

const initialFingers = {
	pulgar: 0,
	indice: 0,
	medio: 0,
	anular: 0,
	menique: 0
};

const validationSchema = Yup.object().shape({
	biometric_id: Yup.string().required().nullable(),
	biometric_type: Yup.string().nullable(),
	dedos: Yup.array()
		.of(
			Yup.object().shape({
				mano_id: Yup.string(),
				dedo_id: Yup.string()
			})
		)
		.test({
			message: 'La selección no corresponde con el formato del biométrico',
			test: (dedos, schema) => {
				if (!dedos) {
					return true;
				}
				if (schema.parent.biometric_type === '2') {
					const pulgares = dedos?.filter((dedo) => dedo.dedo_id === 'pulgar');
					if (pulgares?.length !== 0 && pulgares?.length !== 2) {
						return false;
					}
					const izquierda = dedos?.filter(
						(dedo) => dedo.mano_id === 'izquierda' && dedo.dedo_id !== 'pulgar'
					);
					if (izquierda?.length !== 0 && izquierda?.length !== 4) {
						return false;
					}
					const derecha = dedos?.filter(
						(dedo) => dedo.mano_id === 'derecha' && dedo.dedo_id !== 'pulgar'
					);
					if (derecha?.length !== 0 && derecha?.length !== 4) {
						return false;
					}
				}
				return true;
			}
		})
		.when('biometric_id', (biometric_id, schema) => {
			return !!biometric_id
				? schema.required('Seleccione una sección o dedo a capturar')
				: schema;
		})

		.nullable()
});

export { initialFingers, validationSchema };
